import { type InferType, number, object, string } from "yup";

export const timeSelectFormSchema = object({
  label: string().required(),
  value: object({
    hours: number().required(),
    minutes: number().required(),
  }),
});

export type TTimeSelectFormResolver = InferType<typeof timeSelectFormSchema>;
